import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { buildInvoiceOrBillLockedSuffix } from "@components/transactions/matchedInvoiceOrBillLock";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";
import { useCommands } from "./useCommands";

export const TransactionBulkCoaCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { returnToRoot } = useCommands();
    const {
        selectedTransactionCount = 0,
        transactionBulkCoaOptions = [],
        transactionBulkCoaHeading = "cash ledger",
        transactionsLockedByInvoiceOrBillCount = 0,
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set ${transactionBulkCoaHeading} for ${pluralizeWithCount("transaction", selectedTransactionCount)}${buildInvoiceOrBillLockedSuffix(transactionsLockedByInvoiceOrBillCount)}`}
            options={transactionBulkCoaOptions}
            onOptionSelected={returnToRoot}
        />
    );
};
